import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { Question } from '../models/question';
import { Scenario, ScenarioPart, ExceptingScenario } from '../models/scenario';
import { Product, ProductFav, ProductExt } from '../models/product';
import { Config } from '../models/config';

import { AppSettings } from '../app/app.settings';
import { Tools } from '../tools/tools';
import { Store } from '../models/store';
import {TranslateService} from '@ngx-translate/core';


@Injectable()
export class DataProvider {
  public FAV_PRODUCTS_COUNT = 0;
  public PRODUCT_ID_FOR_ASK = 0;

  public CURRENT_COUNTRY = 'uk';
  public COUNTRY_LAT: number = 51.508530;
  public COUNTRY_LNG: number = -0.076132;

  public scenariosObject: ScenarioPart;
  //public config: Config;

  constructor(private http: HttpClient, private translate: TranslateService) {
    console.log('Navigator Language: ', navigator.language);
    let localLang = navigator.language.substring(0,2).toLocaleLowerCase();

    if (localLang === 'de') {
      translate.setDefaultLang('de');
      translate.use('de');
      localStorage.setItem("es-language", 'de');
      this.CURRENT_COUNTRY = 'de';
      this.COUNTRY_LAT = 48.137154;
      this.COUNTRY_LNG = 11.576124;
      document.documentElement.style.setProperty('--current-country', 'de');
    } else {
      localStorage.setItem("es-language", 'en');
      translate.setDefaultLang('en');
      translate.use('en');
    }
  }

  public loadScenarios() {
    return new Promise((resolve, reject) => {
      if (this.scenariosObject) resolve('exists');
      this.getScenarios()
        .subscribe(scenarioData => {
          let scenarios = scenarioData;

          this.getProducts()
            .subscribe(productData => {

              let availableProductIds: number[] = productData.filter(p => p.available === 1).map(p => p.id);
              this.continueLoadScenarios(resolve, scenarios, availableProductIds);

            });
        });
    })
  }

  private continueLoadScenarios(/*hiddenProductIDs: any, */resolve: any, scenarios: Scenario[], availableProductIds: number[] /*, productData: Product[]*/) {
    this.getQuestions().subscribe(data => {

      let questionTexts = data.sort((q1, q2) => {
        if (q1.sort > q2.sort) return 1;
        if (q1.sort < q2.sort) return -1;
        return 0;
      }).map(q => q.question_text);
      questionTexts.push(AppSettings.RESULT_FIELD)
      for (let prodType of AppSettings.PROD_TYPES) {
        questionTexts.push(AppSettings.RESULT_FIELD + '_' + prodType);
      }

      let scenarioHead = new ScenarioPart();
      for (let scenario of scenarios) {
        let currentPart: ScenarioPart = scenarioHead;
        let newAnswer = null;

        for (let questionText of questionTexts) {
          newAnswer = scenario[questionText] ? scenario[questionText].toString().trim() : scenario[questionText];

          if (newAnswer) {
            if (!currentPart.question) {
              currentPart.question = questionText;
            }

            if (questionText === AppSettings.RESULT_FIELD) {
              currentPart.answers = {};
              for (let prodType of AppSettings.PROD_TYPES) {
                let productIdList = this.parseNumberArray((scenario[AppSettings.RESULT_FIELD + '_' + prodType]).toString())
                  .filter(p => availableProductIds.indexOf(p) !== -1);

                if (productIdList.length > 0) {
                  currentPart.answers[prodType] = productIdList;
                }
              }
            }
            else {
              if (!currentPart.answers)
                currentPart.answers = {};

              if (!currentPart.answers[newAnswer]) {
                currentPart.answers[newAnswer] = new ScenarioPart();
              }

              let prevPart: ScenarioPart = currentPart;
              currentPart = currentPart.answers[newAnswer];
              currentPart.parent = prevPart;
            }
          }

          if (questionText === AppSettings.RESULT_FIELD) {
            this.removeEmptyBranches(currentPart, scenario);
            break;
          }
        }
      }
      this.scenariosObject = scenarioHead;
      this.RecurseTree(scenarioHead, null);
      resolve('created');
    });
  }

  private RecurseTree(currentPart: ScenarioPart, currentAnswer: string) {
    if (!currentPart || !currentPart.answers || currentPart.question === AppSettings.RESULT_FIELD) return;

    let answers = Object.getOwnPropertyNames(currentPart.answers);

    for (let answer of answers) {

      this.RecurseTree(currentPart.answers[answer], answer);


      let childPart: any = currentPart.answers[answer];
      if (!childPart || !childPart.answers || Object.getOwnPropertyNames(childPart.answers).length === 0) {
        delete currentPart.answers[answer];
      }
      let updatedAnswers = (childPart && childPart.answers) ? Object.getOwnPropertyNames(childPart.answers) : [];
      if (childPart.question !== AppSettings.RESULT_FIELD) {
        if (updatedAnswers.length === 1) {
          let lastAnswer: string = updatedAnswers[0];
          currentPart.answers[answer] = childPart.answers[lastAnswer];
          childPart.parent = currentPart.parent;
        }
      }
      else if (answers[answers.length - 1] === answer) {
        //remove last question if result is the same
        let allResultsAreSame: boolean = answers.length > 1;
        if (allResultsAreSame) {
          for (let i = 0; i < answers.length - 1; i++) {
            let childScenarioPart1 = currentPart.answers[answers[i]];
            let childScenarioPart2 = currentPart.answers[answers[i + 1]];
            if (childScenarioPart1.question !== AppSettings.RESULT_FIELD || childScenarioPart2.question !== AppSettings.RESULT_FIELD) {
              allResultsAreSame = false;
              break;
            }
            if (!Tools.isEqual(childScenarioPart1.answers, childScenarioPart2.answers)) {
              allResultsAreSame = false;
              break;
            }
          }
        }
        if (allResultsAreSame) {
          let parentPart: ScenarioPart = currentPart.parent;
          let childPart: ScenarioPart = currentPart.answers[answers[0]];
          childPart.parent = parentPart;
          parentPart.answers[currentAnswer] = childPart;
          //return;
        }
      }
    }
  }

  private removeEmptyBranches(currentPart: ScenarioPart, currentScenario: Scenario) {
    //check out two highest levels
    if (currentPart.parent && currentPart.parent.answers) {
      let answers = Object.getOwnPropertyNames(currentPart.answers);
      if ((!currentScenario[AppSettings.RESULT_FIELD] || answers.length === 0))
        delete currentPart.parent.answers[currentScenario[currentPart.parent.question]];

      if (currentPart.parent.parent && currentPart.parent.parent.answers) {
        if (Object.getOwnPropertyNames(currentPart.parent.answers).length === 0)
          delete currentPart.parent.parent.answers[currentScenario[currentPart.parent.parent.question]];
      }
    }
  }

  private parseNumberArray(arrayStr: string) {
    return arrayStr.split(',').map(p => p.trim()).filter(p => p).map(p => +p);
  }

  public getConfig(): Observable<Config> {
    return this.http.get(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/config.json`/*, this.requestOptions*/)
      //.map(res => res.json())
      .catch(error => {
        console.log(error);
        return Observable.throw(error)
      });
  }

  public getStores(lat: number, lng: number): Observable<Store[]> {
    const path = `https://digi-navi.com/gw/?country=${this.CURRENT_COUNTRY}&lat=${lat}&lon=${lng}`;

    return this.http.get(`${path}`)
      .catch(error => {
        return Observable.throw(error)
      });
  }

  public getScenarios(): Observable<Scenario[]> {
    return this.http.get(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/scenarios.json`/*, this.requestOptions*/)
      //.map(res => res.json())
      .catch(error => {
        console.log(error);
        return Observable.throw(error)
      });
  }

  public getQuestions(): Observable<Question[]> {
    return this.http.get(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/questions.json`/*, this.requestOptions*/)
      //.map(res => res.json())
      .catch(error => {
        console.log(error);
        return Observable.throw(error)
      });
  }

  public getPlanograms(): Observable<any> {
    return this.http.get(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/planograms.json`/*, this.requestOptions*/)
      //.map(res => res.json())
      .catch(error => {
        console.log(error);
        return Observable.throw(error)
      });
  }

  public getProductExceptions(gender: string, howOld: string, scenarioString: string): Observable<number[]> {
    return this.http.get<ExceptingScenario[]>(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/exceptions.json`/*, this.requestOptions*/)
      .map(res => res.filter(e => (!e.gender || e.gender === gender) && (!e.howOld || e.howOld === howOld) && (!e.path || scenarioString.startsWith(e.path.trim())))
        .map(e => e.productIdList.split(',').map(i => +i.trim()))
        .reduce((a, b) => a.concat(b), new Array()))
      .catch(error => {
        console.log(error);
        return Observable.throw(error)
      });
  }

  public getProducts(): Observable<Product[]> {
    return this.http.get<Product[]>(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/products.json`/*, this.requestOptions*/)
      .catch(error => {
        console.log(error);
        return Observable.throw(error);
      });
  }

  public getProductsExt(): Observable<ProductExt[]> {
    return this.http.get<ProductExt[]>(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/products_ext.json`/*, this.requestOptions*/)
      .catch(error => {
        console.log(error);
        return Observable.throw(error);
      });
  }

  public getLocalHiddenProductIDs(): Observable<number[]> {
    return this.http.get<number[]>(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/hidden_products.json`/*, this.requestOptions*/)
      .catch(error => {
        console.log(error);
        return Observable.throw(error);
      });
  }

  public getProductsByIDs(productIdList: number[]): Observable<Product[]> {
    return this.http.get<Product[]>(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/products.json`/*, this.requestOptions*/)
      .map(res => res
        .filter(p => productIdList.indexOf(p.id) !== -1 && p.available === 1)
        .sort((product1, product2) => {
          let index1 = productIdList.indexOf(product1.id);
          let index2 = productIdList.indexOf(product2.id);
          if (index1 > index2) return 1;
          if (index1 < index2) return -1;
          return 0;
        }))
      .catch(error => {
        console.log(error);
        return Observable.throw(error)
      });
  }

  public getProductsExtByIDs(productIdList: number[]): Observable<ProductExt[]> {
    return this.http.get<ProductExt[]>(`${AppSettings.URL_ROOT}assets/${this.CURRENT_COUNTRY}/data/products_ext.json`/*, this.requestOptions*/)
      .map(res => res
        .filter(p => productIdList.indexOf(p.id) !== -1)
        .sort((product1, product2) => {
          let index1 = productIdList.indexOf(product1.id);
          let index2 = productIdList.indexOf(product2.id);
          if (index1 > index2) return 1;
          if (index1 < index2) return -1;
          return 0;
        }))
      .catch(error => {
        console.log(error);
        return Observable.throw(error)
      });
  }

  public getFavProducts(): ProductFav[] {
    let favStr = localStorage.getItem('es-favourites');
    return favStr ? <ProductFav[]>JSON.parse(favStr) : [];
  }

  public setFavProducts(favProds: ProductFav[]) {
    localStorage.setItem('es-favourites', JSON.stringify(favProds));
    this.FAV_PRODUCTS_COUNT = favProds.length;
  }
}



// WEBPACK FOOTER //
// ./src/providers/data.ts